import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { bonusAdminBody } from "./bonusAdminBody";
import type { TemplateIn } from "../../components/Promotions/DynamicBonuses/types";

type StoredToken = { AccessToken?: string };

async function fetchTemplateClone(templateId: string): Promise<TemplateIn> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = API_ROUTES.CLONE_DYNAMIC_BONUS_TEMPLATE.replace("{template_id}", templateId);
  const response = await instance.get(url);
  const clone = bonusAdminBody<TemplateIn>(response);
  if (!clone) {
    throw new Error("Template clone preview not found");
  }
  return clone;
}

export const getTemplateCloneQueryKey = (templateId: string) =>
  ["CLONE_DYNAMIC_BONUS_TEMPLATE", templateId] as const;

export const useGetTemplateClone = (templateId: string) => {
  return useQuery<TemplateIn>({
    queryKey: getTemplateCloneQueryKey(templateId),
    queryFn: () => fetchTemplateClone(templateId),
    enabled: Boolean(templateId),
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
